import React, { useState, useEffect } from "react";
import { useFormContext, Controller, useWatch } from "react-hook-form";
import { allCountries } from "country-telephone-data";
import flag from "emoji-flags";
import "./CustomPhoneInput.css";

const CustomPhoneInput = ({ attribute }) => {
  const {
    name,
    placeholder,
    ...rest
  } = attribute;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const defaultCountry = allCountries.find((country) => country.iso2 === "in");
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const fieldValue = useWatch({
    control,
    name,
    defaultValue: "",
  });

  const {dialCode, iso2} = selectedCountry;

  useEffect(() => {
    if (fieldValue === "") {
      setPhoneNumber("");
    }
  }, [fieldValue]);

  // Filter countries based on search query (name or dial code with + symbol)
  const filteredCountries = allCountries.filter((country) => {
    const searchLower = searchQuery.toLowerCase();
    const dialCodeWithPlus = `+${country.dialCode}`; // Add + to the dial code
    return (
      country.name.toLowerCase().includes(searchLower) || // Search by name
      dialCodeWithPlus.includes(searchQuery) // Search by dial code with +
    );
  });

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
  };

  // Get flag emoji for a country
  const getFlagEmoji = (iso2) => {
    const countryFlag = flag.countryCode(iso2);
    return countryFlag ? countryFlag.emoji : "🌍";
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    // Remove the country code prefix if it exists
    const rawNumber = value.replace(`+${selectedCountry.dialCode}`, "").trim();
    setPhoneNumber(rawNumber);
  };

  // Format phone number with country code
  const formatPhoneNumberWithCountryCode = (phoneNumber, country) => {
    return `+${country.dialCode}${phoneNumber}`;
  };

  const handleToggle = (event) => {
    event.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const invalied = errors[name] ? "invalid" : "";

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <div className="phone-input-container">
          <div className="country-select">
            <button className={`dropdown-toggle ${invalied}`} onClick={handleToggle}>
              <span className="flag">{getFlagEmoji(selectedCountry.iso2)} +{dialCode}</span>
            </button>

            {isDropdownOpen && (
              <div className="dropdown-menu">
                <input
                  type="text"
                  placeholder="Search countries..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />

                <div className="country-list">
                  {filteredCountries.map((country) => (
                    <div
                      key={country.iso2}
                      className="country-item"
                      onClick={() => handleCountrySelect(country)}
                    >
                      <span className="flag">{getFlagEmoji(country.iso2)}</span>
                      <span className="country-name">{country.name}</span>
                      <span className="dial-code">+{country.dialCode}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {errors[name] && (
            <p className="errorMesg">{errors[name].message}</p>
          )}
          <input
            {...field}
            {...rest}
            type="text"
            value={phoneNumber}
            onChange={(e) => {
              handlePhoneNumberChange(e);
              field.onChange(e);
            }}
            placeholder={placeholder}
            className={`phone-input ${invalied}`}
          />
        </div>
      )}
    />
  );
};

export default CustomPhoneInput;